export const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
export const TOGGLE = 'TOGGLE'
export const TOGGLE_VISIBILITY = 'TOGGLE_VISIBILITY'
export const NOTIFICATION = 'NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const UPDATE_UNREAD_COUNT = 'UPDATE_UNREAD_COUNT'
